import React, { useState, ChangeEvent } from "react";
import { useHistory } from "react-router-dom";

import { StatusCode } from "api/protocols";

import { TProductType } from "redux/reducers/models/product";

import { showError } from "redux/actions/ui";
import { useAppDispatch } from "hooks/redux";

import Page from "components/page/Page";
import Card from "components/card/Card";
import Input from "components/form/input/Input";
import { TPostProductTypeParams } from "api/rpc/2022-09/facilityAdmin/product/product";
import { PostProductType } from "api/rpc/2024-04/facilityAdmin/product/type";
import { useTranslation } from "react-i18next";
import FormLayout from "components/form/FormLayout";
import SelectNew from "components/select/SelectNew";
import { errorMessage, productTypeGroups } from "helpers/Helpers";

export default function ProductTypeNew() {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [type, setType] = useState<Partial<TProductType>>({
    // id: null,
    // client_id: null,
    title: "",
    // locked: false,
    group: "none",
  });

  async function addProductType() {
    const params: TPostProductTypeParams = {
      title: type.title,
      group: type.group === "none" ? null : type.group,
    };

    const res = await PostProductType(params, true);

    if (res.status !== StatusCode.OK) {
      dispatch(showError(errorMessage(res, t("Error creating product type"))));
      return;
    }

    history.push("/admin/settings/types");
  }

  return (
    <Page
      title={t("New Product Type")}
      breadcrumbs={[{ prefix: true, label: t("Types"), url: "/admin/settings/types" }]}
      primaryAction={{
        action: () => addProductType(),
        content: t("Save"),
        disabled: type.title.length === 0,
      }}
    >
      <Card>
        <Card.Section>
          <FormLayout>
            <FormLayout.Group>
              <Input
                label={t("Title")}
                value={type.title}
                onChange={(e: ChangeEvent<HTMLInputElement>) => setType(prev => ({ ...prev, title: e.target.value }))}
              />
            </FormLayout.Group>
            <FormLayout.Group>
              <SelectNew
                id="groups"
                placeholder={t("Group")}
                label={t("Group")}
                value={type?.group}
                options={productTypeGroups(t)}
                onChange={id => setType(prev => ({...prev, group: id}))}
                tooltip={t("Assign a group to count this product type's sales toward the group's column in the Server Summaries report.")}
              />
            </FormLayout.Group>
          </FormLayout>

        </Card.Section>
      </Card>
    </Page>
  );
}
